module.exports = __webpack_public_path__ + "media/348477__jalastram__gui-sound-effects-044.6369752d.mp4";